// extracted by mini-css-extract-plugin
export default {"container":"pageLayout_container__S27dd","rightPanel":"pageLayout_rightPanel__Sz0sk"};